/* BLNG Agency only. Native contact forms remain responsible for submission. */
(function () {
  'use strict';
  if (location.protocol !== 'https:' ||
      ['blngagency.com', 'www.blngagency.com'].indexOf(location.hostname) === -1 ||
      window.BLNGAgencyTrackingV2) return;
  window.BLNGAgencyTrackingV2 = true;

  var AW = 'AW-18388908601';
  var DESTINATION = AW + '/StRzCJ79ouEcELn0wcBE';
  var QUEUE = 'blngAgencyDataLayer';
  var PENDING = 'blng_agency_pending_v2';
  var SENT = 'blng_agency_sent_v2';
  var ATTRIBUTION = 'blng_agency_attribution_v2';
  var MAX_AGE = 30 * 60 * 1000;
  var keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term',
    'utm_content', 'gclid', 'gbraid', 'wbraid'];
  var entryParams = new URLSearchParams(location.search);
  var tagState = 'idle';
  var tagPromise;
  var cancelTag;
  var dispatching = false;

  function read(key) {
    try { return JSON.parse(sessionStorage.getItem(key)); }
    catch (error) { return null; }
  }
  function write(key, value) {
    try {
      var serialized = JSON.stringify(value);
      sessionStorage.setItem(key, serialized);
      return sessionStorage.getItem(key) === serialized;
    } catch (error) { return false; }
  }
  function remove(key) {
    try { sessionStorage.removeItem(key); } catch (error) {}
  }
  function allowed() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    try {
      return !!privacy && typeof privacy.marketingAllowed === 'function' &&
        privacy.marketingAllowed() === true;
    } catch (error) { return false; }
  }
  function formIdentity(form) {
    if (!form || (form.tagName && form.tagName.toUpperCase() !== 'FORM') ||
        typeof form.querySelector !== 'function' ||
        !/^[A-Za-z][A-Za-z0-9_:.-]{0,127}$/.test(form.id) ||
        !form.querySelector('[data-blng-attribution]')) return null;
    var action;
    try { action = new URL(form.action, location.href); }
    catch (error) { return null; }
    if (action.origin !== location.origin || action.pathname !== '/contact') return null;
    var input = form.querySelector('[name="contact[Source]"]');
    var source = input && input.value;
    if (typeof source !== 'string' || !source.trim() || source.length > 250) return null;
    return { form: form.id, source: source };
  }
  function clearAttribution() {
    remove(ATTRIBUTION);
    document.querySelectorAll('[data-blng-attribution]').forEach(function (input) {
      input.value = '';
    });
  }
  function attribution() {
    var saved = read(ATTRIBUTION);
    var values = Object.create(null);
    var incoming = keys.some(function (key) { return entryParams.has(key); });
    keys.forEach(function (key) {
      var value = incoming ? entryParams.get(key) :
        (saved && saved.version === 1 && saved.values && saved.values[key]);
      if (typeof value === 'string' && value) values[key] = value.slice(0, 1000);
    });
    if (incoming) write(ATTRIBUTION, { version: 1, values: values });
    document.querySelectorAll('[data-blng-attribution]').forEach(function (input) {
      var key = input.dataset.blngAttribution;
      input.value = keys.indexOf(key) !== -1 ? (values[key] || '') : '';
    });
  }
  function agencyTag() {
    window[QUEUE].push(arguments);
  }
  function loadTag() {
    if (tagState === 'loaded') return Promise.resolve();
    if (tagPromise) return tagPromise;
    window[QUEUE] = window[QUEUE] || [];
    // Standard gtag ordering, on the dedicated agency queue only.
    agencyTag('js', new Date());
    agencyTag('config', AW, {
      send_page_view: false,
      allow_ad_personalization_signals: false
    });
    tagState = 'loading';
    tagPromise = new Promise(function (resolve, reject) {
      var settled = false;
      var script = document.createElement('script');
      script.async = true;
      script.src = 'https://www.googletagmanager.com/gtag/js?id=' + AW + '&l=' + QUEUE;
      function cancel() {
        if (settled) return;
        settled = true;
        window[QUEUE].length = 0;
        script.remove();
        tagState = 'idle';
        tagPromise = null;
        cancelTag = null;
        reject(new Error('Agency tag unavailable or consent withdrawn'));
      }
      cancelTag = cancel;
      script.onerror = cancel;
      script.onload = function () {
        if (settled) return;
        if (!allowed()) { cancel(); return; }
        settled = true;
        tagState = 'loaded';
        cancelTag = null;
        resolve();
      };
      document.head.appendChild(script);
    });
    return tagPromise;
  }
  function matchingPending() {
    var pending = read(PENDING);
    if (!pending || pending.version !== 1 ||
        typeof pending.id !== 'string' ||
        !/^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(pending.id) ||
        !Number.isFinite(pending.time) || Date.now() < pending.time ||
        Date.now() - pending.time > MAX_AGE ||
        typeof pending.path !== 'string' || typeof pending.form !== 'string' ||
        typeof pending.source !== 'string') {
      remove(PENDING);
      return null;
    }
    if (pending.path !== location.pathname || read(SENT) === pending.id) return null;
    var markers = document.querySelectorAll('[data-blng-agency-lead-success="true"]');
    return Array.prototype.some.call(markers, function (marker) {
      var identity = formIdentity(marker.closest('form'));
      return identity && identity.form === pending.form && identity.source === pending.source;
    }) ? pending : null;
  }
  function processConsent() {
    keys.forEach(function (key) { remove('blng_' + key); });
    remove('blng_agency_lead_fired');
    if (!allowed()) {
      clearAttribution();
      remove(PENDING);
      if (cancelTag) cancelTag();
      return;
    }
    attribution();
    loadTag().then(function () {
      if (!allowed() || dispatching) return;
      var pending = matchingPending();
      if (!pending) return;
      // Persist dedupe only after Google loaded, immediately before dispatch.
      // If storage is unavailable, preserve the form and skip measurement.
      if (!write(SENT, pending.id)) return;
      dispatching = true;
      remove(PENDING);
      agencyTag('event', 'conversion', {
        send_to: DESTINATION,
        transaction_id: pending.id
      });
      dispatching = false;
    }).catch(function () { /* Retain pending after a network failure. */ });
  }
  document.addEventListener('submit', function (event) {
    var form = event.target;
    var identity = formIdentity(form);
    if (!identity || typeof form.checkValidity !== 'function' || !form.checkValidity()) return;
    if (!allowed() || !window.crypto || typeof window.crypto.randomUUID !== 'function') {
      remove(PENDING);
      return;
    }
    attribution();
    write(PENDING, {
      version: 1, id: window.crypto.randomUUID(), time: Date.now(),
      path: location.pathname, form: identity.form, source: identity.source
    });
  }, true);
  document.addEventListener('visitorConsentCollected', processConsent);

  function initializePrivacy(attempt) {
    if (window.Shopify && window.Shopify.customerPrivacy &&
        typeof window.Shopify.customerPrivacy.marketingAllowed === 'function') {
      processConsent();
    } else if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }],
        function (error) {
          if (!error && window.Shopify.customerPrivacy &&
              typeof window.Shopify.customerPrivacy.marketingAllowed === 'function') {
            processConsent();
          } else if (attempt < 40) {
            setTimeout(function () { initializePrivacy(attempt + 1); }, 250);
          }
        });
    } else if (attempt < 40) {
      setTimeout(function () { initializePrivacy(attempt + 1); }, 250);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initializePrivacy(0); }, { once: true });
  } else {
    initializePrivacy(0);
  }
})();
